import { Component, OnInit, Input, ViewChild, ElementRef, ViewChildren, Output, EventEmitter } from '@angular/core';
import { CharacteristicObject } from 'src/app/models/characteristics/characteristic/characteristic-object.model';
import { MultiCharacteristicObject } from 'src/app/models/characteristics/characteristic/multi-characteristic-object.model';

@Component({
  selector: 'app-multi-field',
  templateUrl: './multi-field.component.html',
  styleUrls: ['./multi-field.component.css']
})
export class MultiFieldComponent implements OnInit {

  @Input() characteristic: MultiCharacteristicObject;
  @Input() editable: boolean;
  @Output() characteristicEvent = new EventEmitter<CharacteristicObject>();

  characteristicOriginal: MultiCharacteristicObject;
  newValue: Array<string>;

  diffPhrase: string;
  value: string;
  hover: boolean;

  characToDisplay: string;

  autofocus: boolean;

  placeholder: string = "vacío";

  @ViewChild('valueInput', { static: false }) valueInput: ElementRef;

  constructor() {

  }

  ngOnInit() {
    this.autofocus = false;
    this.diffPhrase = '';
    this.characteristicOriginal = this.characteristic.clone();
  }

  ngAfterViewChecked() {
    if (this.autofocus === true) {
      this.valueInput.nativeElement.focus();
      this.autofocus = false;
    }
  }

  onEdit() {
    if (!this.editable) return;

    this.characteristic.mode = 'EDITING';
    this.newValue = new Array<string>();
    for (let i = 0; i < this.characteristicOriginal.value.length; i++) {
      this.newValue[i] = this.characteristic.value[i];
    }
    this.autofocus = true;
  }

  public resetInputValue(index: number) {
    this.characteristic.value[index] = this.characteristicOriginal.value[index];
    this.newValue[index] = this.characteristicOriginal.value[index];
  }

  public acceptNewInputValues() {
    let edited: boolean = false;
    for (let i = 0; i < this.characteristicOriginal.value.length; i++) {
      if (this.characteristicOriginal.value[i] !== this.newValue[i]) {
        this.characteristic.value[i] = this.newValue[i];
        edited = true;
      }
    }
    if (edited) {
      this.setEditValue('EDITED');
    } else {
      this.setEditValue('DEFAULT');
    }
  }

  public setEditValue(mode: string) {
    this.characteristic.mode = mode;
    this.diffPhrase = 'Valor anterior: ' + this.characteristicOriginal.value.join(', ') + '';
    this.characteristicEvent.emit(this.characteristic);
  }

  public getValueAsString() {
    return this.characteristic.value.join(', ');
  }

}
